import { CFPlans } from "./CompanyFormationCorpnet/CFPlans";
import CoverdashQuotes from "./CoverdashQuotes";
import { PEClientsList } from "./Partner-Employee/PEClientsList";
import { TaxRegistrationForm } from "./TaxRegistrationCorpnet/TaxRegistrationForm";
import PackagesPricing from "../PackagesPricing";
import ChatBot from "./ChatBot/ChatBot";
import DomainLandingPagesApp from "Domain Landing Pages/App";
import UserSystemGuide from "./UserSystemGuide";
import HRPortalApp from "HR Portal/src/App";
import DoWTRLAssessment from "./DoWTRLAssessment";
import WebsiteDevelopment from "./WebsiteDevelopment";
import App from "Corpnet/App";
import { DomainResellerFlow } from "../DomainSearch";

export const CustomReactComponents = ({
  component,
  domain,
  sendKeys = false,
}) => {
  const components = {
    "partner-employee-clients": {
      title: "Partner & Employee Clients",
      component: <PEClientsList domain={domain} />,
      description: "Manage partner and employee client relationships",
    },
    "company-formation-form-1": {
      title: "Company Formation Plans",
      component: <CFPlans />,
      description: "Browse and select company formation packages from corpnet",
    },
    "tax-registration-form-1": {
      title: "Tax Registration Form",
      component: <TaxRegistrationForm />,
      description: "Complete tax registration process from corpnet",
    },
    "human-resources-landing": {
      title: "Human Resources Landing Page",
      component: <DomainLandingPagesApp domain_id={1} />,
      description: "Landing page for Human Resources services",
    },
    "bookkeeping-landing": {
      title: "Bookkeeping Landing Page",
      component: <DomainLandingPagesApp domain_id={2} />,
      description: "Landing page for Bookkeeping services",
    },
    "tax-services-landing": {
      title: "Tax Services Landing Page",
      component: <DomainLandingPagesApp domain_id={3} />,
      description: "Landing page for Tax Services",
    },
    "company-formation-landing": {
      title: "Company Formation Landing Page",
      component: <DomainLandingPagesApp domain_id={4} />,
      description: "Landing page for Company Formation services",
    },
    "patent-services-landing": {
      title: "Patent Services Landing Page",
      component: <DomainLandingPagesApp domain_id={5} />,
      description: "Landing page for Patent Services",
    },
    "business-insurance-landing": {
      title: "Business Insurance Landing Page",
      component: <DomainLandingPagesApp domain_id={6} />,
      description: "Landing page for Business Insurance services",
    },
    "domain-packages-pricing": {
      title: "Domain Packages & Pricing",
      component: <PackagesPricing domain={domain} />,
      description: "View available packages and pricing for this domain",
    },
    "domain-chat-bot": {
      title: "AI Chat Assistant",
      component: <ChatBot domain={domain} />,
      description:
        "Get instant help and support through AI chat specialised in this domain",
    },
    "human-resources-portal": {
      title: "Human Resources Portal",
      component: <HRPortalApp asPortal={false} />,
      description: "Access HR management tools and resources",
    },
    "legal-services-landing": {
      title: "Legal Services Page",
      component: <DomainLandingPagesApp domain_id={7} />,
      description: "Landing page for Legal Services",
    },
    "legal-business-contracts-landing": {
      title: "Legal-Business Contracts & Agreements",
      component: <DomainLandingPagesApp domain_id={8} />,
      description: "Landing page for Legal Business Contracts and Agreements",
    },
    "legal-ip-property-protection-landing": {
      title: "Legal - IP Property Protection",
      component: <DomainLandingPagesApp domain_id={9} />,
      description: "Landing page for Legal IP Property Protection",
    },
    "sam-gov-registration-landing": {
      title: "SAM.gov Registration & UEI Assistance",
      component: <DomainLandingPagesApp domain_id={10} />,
      description:
        "Landing page for SAM.gov Registration & UEI Assistance in Government Contracting",
    },
    "bizserve-portal-home": {
      title: "BizServe Portal Home Page",
      component: <DomainLandingPagesApp domain_id={11} />,
      description:
        "All-in-one business management platform homepage for small businesses and government contractors",
    },
    "user-system-guide": {
      title: "User System Guide",
      component: <UserSystemGuide />,
      description:
        "Comprehensive guide for customers to understand how the BizServe platform operates, including services, workflows, and support options",
    },
    "dod-trl-assessment": {
      title: "DoD Technology Readiness Level Assessment",
      component: <DoWTRLAssessment />,
      description:
        "Interactive assessment tool for Department of Defense Technology Readiness Levels (TRL 1-9) with visual guides and detailed explanations",
    },
    "website-development": {
      title: "Website Development Services",
      component: <DomainLandingPagesApp domain_id={12} />,
      description:
        "Professional website development services including responsive design, e-commerce solutions, CMS, SEO optimization, and more",
    },
    "cmmc-cybersecurity-landing": {
      title: "CMMC Cybersecurity Compliance",
      component: <DomainLandingPagesApp domain_id={13} />,
      description:
        "Landing page for CMMC (Cybersecurity Maturity Model Certification) compliance services — gap analysis, SSP drafting, POA&M, and C3PAO assessment readiness for DoD contractors",
    },
    "corpnet-home": {
      title: "CorpNet Home",
      component: <App />,
      description:
        "CorpNet home page",
    },
    "domain-reseller-flow": {
      title: "Domain Reseller Flow",
      component: <DomainResellerFlow />,
      description:
        "Complete domain registration flow with name.com API integration - search, pricing, registration, contacts, DNS configuration, and options",
    },
    "coverdash-quotes": {
      title: "Coverdash Insurance Quotes",
      component: <CoverdashQuotes />,
      description:
        "Get business insurance quotes via Coverdash partner cobrand embed",
    },
  };

  if (sendKeys) {
    return Object.keys(components).map((key) => ({
      key: key,
      title: components[key].title,
      description: components[key].description,
    }));
  }

  return components[component]?.component || <></>;
};
